// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// for code highlight
require("prismjs/themes/prism-solarizedlight.css")
